import React from 'react'
import { connect } from 'react-redux'

import { Nav, NavItem, ButtonToolbar, Glyphicon } from 'react-bootstrap'

import { rename, removeRoute } from '../ducks/routes'
import { addNewRoute, updateTrip, addClonedRoute } from '../ducks/trips'
import RouteEditor from '../routes/RouteEditor.jsx'
import Button from '../components/Button.jsx'

import { getText } from '../lib/text.js'

type Props = {
  startDate: ?string,
  trip: Object,
  routes: Object,

  Activities: Object,
  Routes: Object,
  AliveActivitiesList: Object[],
  ExpensesList: Object[],
  CitiesList: string[],
  blockTemplatesList: Object[],

  move           : Function,
  multiMove      : Function,
  addActivity    : Function,
  addCity        : Function,
  addDay         : Function,
  addBlock       : Function,
  addExpense     : Function,
  addNote        : Function,
  editItem       : Function,
  updateExpenses : Function,
  remove         : Function,
  createBlock    : Function,
  repeatExpense  : Function,
  moveItem       : Function,

  replaceWithBlock: Function,
  top: number,

  /* self-provided */
  renameTab: (string, string) => void,
  addNewRoute: (string) => void,
  makeMain: (string, string) => void,
  removeRoute: (string, string) => void,
}

class RouteTabber extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      selected: props.trip.mainRoute
    }
  }

  props: Props

  render() {
    const { routes, trip, renameTab } = this.props
    const { selected } = this.state

    return (
      <div style = {{marginTop: "15px"}}>
        <Nav
          bsStyle="tabs"
          activeKey={this.state.selected}
          onSelect={k => this.setState({selected: k})}
          style={{position: "sticky", zIndex: 5, top: '42px', backgroundColor: "white" }}
        >
          <Button
            style = {{marginTop : "6px", marginLeft : "6px"}}
            glyph="plus"
            onClick={() => this.props.addNewRoute(trip._id)}
          />
          {
            trip.routes.map(rid => (
              <NavItem key={rid} eventKey={rid} style={{ fontWeight: rid == this.state.selected ? "bold" : "normal", backgroundColor : rid == this.state.selected ? "white" : "gainsboro", border : "1px solid", borderColor : "silver" }}>
                <Glyphicon glyph="star" style={{ color: rid == trip.mainRoute ? "#FFBF00" : "silver" }} />
                {(routes[rid] && routes[rid].name) || getText("Ruta sin nombre")}
                <Button
                  bsSize="xsmall"
                  onClick={evt => {
                    const name = prompt(getText("🇪🇸 Nombre de la ruta"))
                    if (name) {
                      renameTab(rid, name)
                    }
                  }}
                  style = {{marginLeft : 10, visibility : rid == this.state.selected ? "visible" : "hidden"}}
                  glyph="pencil"

                />
              </NavItem>
            ))
          }
          <ButtonToolbar style = {{float : "right", marginRight : "100px", marginTop: "6px"}}>
            <Button
              disabled={selected == trip.mainRoute}
              glyph="remove"
              onClick={() => {
                this.setState({ selected: trip.mainRoute })
                this.props.removeRoute(trip, selected)
              }}
              label={getText("Eliminar")}
            />
            <Button
              onClick={() => this.props.addClonedRoute(trip._id, selected)}
              glyph="duplicate"
              label={getText("Clonar")}
            />
            <Button
              disabled={selected == trip.mainRoute}
              onClick={() => this.props.makeMain(trip._id, selected)}
              glyph="star"
              label={getText("Seleccionar")}
            />
          </ButtonToolbar>
        </Nav>

        <div>

          <RouteEditor
            id={trip.id}
            route={routes[selected]}
            startDate={trip.startDate}
            blockTemplates={this.props.blockTemplates}
            Activities={this.props.Activities}
            Routes={this.props.Routes}
            trip={trip}
            pGestion = {trip.pGestion}
            useForcedPrice = {trip.useForcedPrice}
            top={4 + 84 /*space for the sticky panel header*/}
            addBlock={this.props.addBlock}
            replaceWithBlock={this.props.replaceWithBlock}
            move={this.props.move}
            addActivity={this.props.addActivity}
            addCity={this.props.addCity}
            addDay={this.props.addDay}
            addExpense={this.props.addExpense}
            addNote={this.props.addNote}
            editItem={this.props.editItem}
            updateExpenses={this.props.updateExpenses}
            remove={this.props.remove}
            multiMove={this.props.multiMove}
            CitiesList={this.props.CitiesList}
            AliveActivitiesList={this.props.AliveActivitiesList}
            blockTemplatesList={this.props.blockTemplatesList}
            createBlock={this.props.createBlock}
            repeatExpense={this.props.repeatExpense}
            moveItem={this.props.moveItem}
            ExpensesList={this.props.ExpensesList}

            isTemplate={false}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
  renameTab: (id, name) => dispatch(rename(id, name)),
  addNewRoute: id => dispatch(addNewRoute(id)),
  addClonedRoute: (id, rid) => dispatch(addClonedRoute(id, rid)),
  makeMain: (id, rid) => dispatch(updateTrip(id, { mainRoute: rid })),

  // WARNING: Logic on view!
  removeRoute: (trip, rid) => {
    dispatch(removeRoute(rid))
    dispatch(updateTrip(trip._id, {
      routes: trip.routes.filter(r => r != rid)
    }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(RouteTabber)
